// @deprecated: Use event-reservation-cart-item instead
import {getNow, parseDateTime, DateTime} from '../../../lib/dates'
import CartMixin from '../../../components/_mixins/location-checkout'
import PageMixins from '../../../components/_mixins/pages'
import ProviderService from '../../../services/event-reservation'
import {coerceBoolean} from '../../../lib/utils'
const EventBus = window.VueEventBus

export default {
  'name': 'clubspeed-event-reservation-axe-throwing-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [PageMixins, CartMixin],
  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    columnClasses: {},
    // valid: {},
    // errors: {},
    error: {}
  },
  data() {
    return {
      itemInvalid: false,
      itemValidationError: null,
      holdId: null
    }
  },
  computed: {
    itemPayload() {
      return _.get(this.item || {}, 'payload', {})
    },
    itemOptions() {
      return this.itemPayload.options || {}
    },
    itemAttributes() {
      return _.get(this.item || {}, 'attributes', {})
    },
    itemForm() {
      return this.itemAttributes.form
    },
    itemProduct() {
      return this.itemAttributes.product
    },
    availableDurations() {
      const durations = _.values(this.itemProduct.durations || [])

      durations.sort((a, b) => {
        return _.toFinite(a.value) - _.toFinite(b.value)
      })

      return _.keyBy(durations, 'value')
    },
    itemSlot() {
      return this.itemAttributes.slot || {}
    },
    itemHold() {
      return this.itemSlot.hold
    },
    itemHoldExpires() {
      // expiration datetime set using UTC timezone in backend
      return DateTime.fromSQL(_.get(this.itemHold, 'expire_at'), {zone: 'UTC'})
    },
    cartItemHasTimedOut() {
      // expiration datetime set using UTC timezone in backend
      const now = getNow('UTC')
      return now > this.itemHoldExpires
    },
    itemTitle() {
      return this.item.title
    },
    itemTypeTitle() {
      return 'Axe Throwing'
    },
    arriveByTime() {
      return this.itemSlot.arriveByTime
    },
    slottedDateFormatted() {
      return this.itemAttributes.formattedDate
    },
    slottedTimeFormatted() {
      return this.itemAttributes.formattedTime
    },
    itemDurationTitle() {
      const duration = this.itemAttributes.duration
      return _.get(this.availableDurations[duration], 'label', duration)
    },
    itemParticipants() {
      return this.itemAttributes.participants
    },
    itemQuantity() {
      return this.itemAttributes.quantity
    },
    itemCount() {
      return this.itemOptions.participants
    },
    itemRate() {
      return this.itemAttributes.pricing.rate
    },
    itemTax() {
      return this.itemAttributes.pricing.tax
    },
    itemSubtotal() {
      return this.itemAttributes.pricing.subtotal
    },
    itemTotal() {
      return this.itemAttributes.pricing.total
    },
  },
  async created() {
    const item = this.item
    const itemId = item.id
    this.holdId = _.get(item, 'attributes.reservation_hold_id')

    EventBus.$once('timer.timeout', async (id) => {
      if (id === this.currentLocationId) {
        const autoRemoveItem = coerceBoolean(this.$$s('timer.expired.items.autoRemove', false))
        this.setTimeoutRemovedTypes([item.editRoute.name])
        this.setTimeoutRemovedItem(this)
        await this.$nextTick()
        this.showTimeoutAlert()
        await this.$nextTick()
        if (autoRemoveItem) {
          this.removeThisCartItem()
        }
      }
    })

    EventBus.$on('timer.timeout', (location) => {
      this.mayResetCountdownTimer()
    })

    EventBus.$on('cart.error.item.expired.validation.' + this.item.id, () => {
      EventBus.$emit('timer.timeout', this.currentLocationId)
    })

    EventBus.$on('cart-cleaned', () => {
      this.unhold()
    })

    EventBus.$on(`cart.validate.before`, () => {
      this.itemInvalid = false
      this.itemValidationError = null
    })

    EventBus.$on(`cart.error.item.validation.${itemId}`, (e) => {
      this.itemInvalid = true
      this.itemValidationError = e.error[0]
    })
  },
  mounted() {
    if (this.cartItemHasTimedOut) {
      EventBus.$emit('timer.timeout', this.currentLocationId)
    } else {
      if (!this.timerIsRunning) {
        EventBus.$emit('timer.timeout', this.currentLocationId)
      }
    }
  },
  methods: {
    removeThisCartItem(skipEvents) {
      this.unhold()
      const item = _.cloneDeep(this.item)
      this.removeCartItem({id: item.id})
      if (!skipEvents) {
        EventBus.$emit('cart-item-deleted', item, this, this.$parent)
        EventBus.$emit('cart-item-deleted-' + item.type, item, this, this. $parent)
      }
    },
    itemDelete($event) {
      const item = _.cloneDeep(this.item)
      this.unsetTimeoutRemovedItem(this)
      this.removeThisCartItem(true)

      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })

      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },
    itemEdit($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        item,
        actionName: 'edit',
        id: this.item.id,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-edit', item, this, this.$parent)
      EventBus.$emit('cart-item-edit-' + item.type, item, this, this.$parent)

      if (item.editRoute) {
        const route = Object.assign({}, item.editRoute, {query: {token: item.id}})
        this.$router.push(route)
      }

    },
    unhold(hold) {
      const id = (hold && hold.id) || hold || this.itemHold.id || this.holdId
      if (id) {
        ProviderService.unhold({id})
      }
    },
  },
}
